import { Toast } from '@renderer/overlay/Toaster'

interface PlanUnverifiedToastProps {
  toastId: string
}

/**
 * The meeting gate refused a start for no entitlement while this client holds
 * a v2 tier. The server couldn't see the plan: billing was down, or the plan
 * lapsed and the refresh sent with this toast will say so. Either way there
 * is nothing to sell, only a start to retry.
 */
export function PlanUnverifiedToast({ toastId }: PlanUnverifiedToastProps) {
  return (
    <Toast toastId={toastId}>
      <Toast.Content>
        <Toast.Description>
          {"We couldn't confirm your plan just now. Try starting the meeting again."}
        </Toast.Description>
      </Toast.Content>
    </Toast>
  )
}
